import Block from '../../block'

export default class ShoppingcartTotal extends Block {
	static title = 'shoppingcart-total'

	constructor($el) {
		super($el)

		if (this.$el.hasModifier('confirmation')) {
			return
		}

		this.subtotal1 = this.$el.findElement('subtotal-excl')
		this.subtotal2 = this.$el.findElement('subtotal-incl')
		this.total = this.$el.findElement('total')
		this.shipping = this.$el.findElement('shipping')

		$(document).on('product:add', (index, data) => {
			this.updateComponent(data)
		})

		$(document).on('product:remove', (index, data) => {
			this.updateComponent(data)
		})

		$(document).on('product:update', (index, data) => {
			this.updateComponent(data)
		})
	}

	updateComponent(data) {
		// the totals are returned as formatted strings, not as numbers
		this.subtotal1.text(Number(data.subtotal1).toFixed(2))
		this.subtotal2.text(Number(data.subtotal2).toFixed(2))
		this.total.text(Number(data.total).toFixed(2))
		this.shipping.text(Number(data.shipping).toFixed(2))
	}
}
